import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const PILLARS = [
  { src: '/quote-quality.svg', alt: 'Quality — "Quality is not an act, it is a habit." — Aristotle' },
  { src: '/quote-commitment.svg', alt: 'Commitment — "Commitment is what transforms a promise into reality." — Abraham Lincoln' },
  { src: '/quote-placement.svg', alt: 'Placement — "The only way to do great work is to love what you do." — Steve Jobs' },
];

export default function TeamSection() {
  const sectionRef = useScrollReveal('.pillar-reveal', { y: 36, stagger: 0.15 });

  return (
    <section ref={sectionRef} id="team" data-testid="team-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="pillar-reveal text-center mb-14">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-[#1F1F1F]">
            Pillars Of Success
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {PILLARS.map((p) => (
            <img key={p.src} src={p.src} alt={p.alt} className="pillar-reveal w-full rounded-2xl shadow-lg" />
          ))}
        </div>
      </div>
    </section>
  );
}
